import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  jsonError: {
    id: 'studio.BdFDsh',
    defaultMessage: 'JSON error: The input value is not valid JSON.',
  },
  yamlError: {
    id: 'studio.3jkGv6',
    defaultMessage: 'YAML error: {error}',
  },
  remapperError: {
    id: 'studio.VT5lYT',
    defaultMessage: 'Remapper: {error}',
  },
});
